module.exports = "/_next/static/images/gh-6ad2b9cb3cf955d04794ee0cbc0a0402.svg";